// import { DateIdUtil } from '@ngcore/core';


export namespace CommonNoteUtil {

  // TBD:
  export function dummy1() {

  }


}
